require('./bootstrap');
require('./scroll');
require('./sentry');

import Banners from './banners/Banners.vue';
import Properties from './properties/Properties.vue';

var app = new Vue({
    el: '#app',
    components: {Banners, Properties},
});



// WEBPACK FOOTER //
// ./themes/ldc/assets/js/app.js